
import {
  GET_AUTHOR_DETAIL_REQUEST,
  GET_AUTHOR_DETAIL_SUCCESS,
  GET_AUTHOR_DETAIL_FAILURE,
  GET_AUTHOR_LAST_COMMENTS_STATUS_REQUEST,
  GET_AUTHOR_LAST_COMMENTS_STATUS_SUCCESS,
  GET_AUTHOR_LAST_COMMENTS_STATUS_FAILURE,
  GET_AUTHOR_RESET,
} from 'Store/constants';
        
const initialState = {
  data: {
    items: [],
    commentResponse: {
      items: [],
      totalPages: 0,
      totalElements: 0,
    },
    recommendationResponse: {
      items: [],
      totalElements: 0,
      totalPages: 0
    }
  },
  page: 0,
  size: 20,
  lastComments: {},
  isLoading: null,
  error: null,
};
        
        
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_AUTHOR_DETAIL_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_AUTHOR_DETAIL_SUCCESS:
      if (action.page === 0) {
        return {
          ...state,
          data: action.payload,
          page: action.page,
          isLoading: false,
          error: null,
        };
      } else {
        return {
          ...state,
          data: {
            ...action.payload,
            items: [...(state?.data?.commentResponse || state?.data?.recommendationResponse)?.items, ...(action.payload?.commentResponse || action.payload?.recommendationResponse)?.items],
            ...state?.data?.commentResponse ? {
              commentResponse: {
                items: [...state?.data?.commentResponse?.items, ...action.payload?.commentResponse?.items],
                totalElements: action?.payload?.commentResponse?.totalElements,
                totalPages: action?.payload?.commentResponse?.totalPages
              }
            } : {
              recommendationResponse: {
                items: [...state?.data?.recommendationResponse?.items, ...action.payload?.recommendationResponse?.items],
                totalElements: action?.payload?.recommendationResponse?.totalElements,
                totalPages: action?.payload?.recommendationResponse?.totalPages
              }
            }
          },
          page: action.page,
          isLoading: false,
          error: null,
        };
      }
        
    case GET_AUTHOR_DETAIL_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    
    case GET_AUTHOR_LAST_COMMENTS_STATUS_REQUEST:
      return { ...state, isLoading: true, error: null };
          
    case GET_AUTHOR_LAST_COMMENTS_STATUS_SUCCESS:
      return { ...state, lastComments: action.payload, isLoading: false, error: null };
          
    case GET_AUTHOR_LAST_COMMENTS_STATUS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case GET_AUTHOR_RESET:
      return { ...state };
    default:
      return state;
  }
};
